import { TermsResource, termsResource } from '@witkac/kartamiejska-resources';
import { ProfileType, Terms } from '@witkac/kartamiejska-shared';

import { AbstractModule } from './abstract.module';

export class TermsModule extends AbstractModule<TermsResource> {
  public state = {
    current: []
  };

  public actions = {
    getCurrent: (context: any, profileType: ProfileType) =>
      this.resource.termsCurrent(profileType).then(terms => {
        context.commit('saveCurrent', terms);
        return terms;
      })
  };

  public mutations = {
    saveCurrent: (localState: any, terms: Terms[]) =>
      (localState.current = terms)
  };
}

export default new TermsModule(termsResource);
